export default __webpack_public_path__ + "static/piscina-espreguicadeiras-a82e467e3dcf228cdb6538f7a9aefc52.webp";